/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
'use strict';

var RequestAnimationFrame = {
  current: function current(cb) {
    return global.requestAnimationFrame(cb);
  },
  inject: function inject(injected) {
    RequestAnimationFrame.current = injected;
  }
};
module.exports = RequestAnimationFrame;